<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검대상</h5>
      </vs-col>
    </vs-row>

    <div class="grid lg:grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <!--        체크 1-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
            {{ inspectionTitle_1 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 2-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
            {{ inspectionTitle_2 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 3-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_3"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_3 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_3"
            ></vs-checkbox>
            {{ inspectionTitle_3 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 4-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_4"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_4 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_4"
            ></vs-checkbox>
            {{ inspectionTitle_4 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 5-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_5"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_5 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_5"
            ></vs-checkbox>
            {{ inspectionTitle_5 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 6-->
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div
            v-if="form.check_6"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_6 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_6"
            ></vs-checkbox>
            {{ inspectionTitle_6 }}
          </span>
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_3"
      :list="form.inspectList_3"
      @update-list-check="updateListCheck_3"
      v-if="form.check_3"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_4"
      :list="form.inspectList_4"
      @update-list-check="updateListCheck_4"
      v-if="form.check_4"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_5"
      :list="form.inspectList_5"
      @update-list-check="updateListCheck_5"
      v-if="form.check_5"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_6"
      :list="form.inspectList_6"
      @update-list-check="updateListCheck_6"
      v-if="form.check_6"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.inspectList_1 ||
          this.form.inspectList_1.length === 0
        ) {
          this.form.inspectList_1 = this.inspectTable_1;
        }
        if (
          !this.form ||
          !this.form.inspectList_2 ||
          this.form.inspectList_2.length === 0
        ) {
          this.form.inspectList_2 = this.inspectTable_2;
        }
        if (
          !this.form ||
          !this.form.inspectList_3 ||
          this.form.inspectList_3.length === 0
        ) {
          this.form.inspectList_3 = this.inspectTable_3;
        }
        if (
          !this.form ||
          !this.form.inspectList_4 ||
          this.form.inspectList_4.length === 0
        ) {
          this.form.inspectList_4 = this.inspectTable_4;
        }
        if (
          !this.form ||
          !this.form.inspectList_5 ||
          this.form.inspectList_5.length === 0
        ) {
          this.form.inspectList_5 = this.inspectTable_5;
        }
        if (
          !this.form ||
          !this.form.inspectList_6 ||
          this.form.inspectList_6.length === 0
        ) {
          this.form.inspectList_6 = this.inspectTable_6;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = `${
          value.check_1 ? this.inspectionTitle_1 : ""
        }
            ${value.check_2 ? this.inspectionTitle_2 : ""}
            ${value.check_3 ? this.inspectionTitle_3 : ""}
            ${value.check_4 ? this.inspectionTitle_4 : ""}
            ${value.check_5 ? this.inspectionTitle_5 : ""}
            ${value.check_6 ? this.inspectionTitle_6 : ""}`;

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle_1: "공통",
      inspectionTitle_2: "굴착기",
      inspectionTitle_3: "고소작업대",
      inspectionTitle_4: "이동식 크레인",
      inspectionTitle_5: "트럭(화물운반트럭, 덤프트럭)",
      inspectionTitle_6: "타워크레인",

      form: {
        inspectionTitle: "",
        stdInfo: {},
        photoList: [],
        check_1: true,
        check_2: false,
        check_3: false,
        check_4: false,
        check_5: false,
        check_6: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
        inspectList_4: [],
        inspectList_5: [],
        inspectList_6: [],
      },
    };
  },
  computed: {
    inspectTable_1() {
      return [
        {
          id: 1,
          label: "자격을 갖춘 자에게 운전을 하도록 하여야 한다.",
          is_checked: "",
          title: "운전자 적정여부",
        },
        {
          id: 2,
          label:
            "형식신고 및 안전인증·검사 등 기계별 필요한 검사를 받았는지 확인한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 3,
          label:
            "건설기계의 운행경로 및 작업방법을 고려해 기계별 작업계획을 수립·이행하고, 작업지휘자를 지정하여 지휘·감독한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 4,
          label: "작업 전 운전자 및 작업자 안전교육을 실시한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 5,
          label:
            "작업장소의 지형 및 지반상태를 확인하고, 기계가 넘어질 우려가 없도록 조치한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 6,
          label:
            "작업구간에 작업자의 출입을 금지하거나 유도자를 배치하여 차량을 유도하여야 한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 7,
          label: "유도자는 정해진 신호방법에 따라 차량을 유도한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 8,
          label: "건설기계는 주된 용도로만 사용하여야 한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 9,
          label: "승차석이 아닌 곳에 작업자를 탑승시키지 않는다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 10,
          label: "지정된 제한속도를 준수하여야 한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 11,
          label: "방호장치를 임의로 해체하지 않는다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 12,
          label:
            "포크, 버킷, 디퍼 등의 장치를 가장 낮은 위치 또는 지면에 내려 두고, 브레이크를 확실히 걸어 갑작스러운 이동을 방지한다.",
          is_checked: "",
          title: "운전위치 이탈 시",
        },
        {
          id: 13,
          label: "운전석 이탈 시 시동키를 운전대에서 분리시킨다.",
          is_checked: "",
          title: "운전위치 이탈 시",
        },
        {
          id: 14,
          label: "작업지휘자를 지정하고 작업순서를 정하여 지휘한다.",
          is_checked: "",
          title: "수리 등 점검 시",
        },
        {
          id: 15,
          label:
            "붐·암 등이 갑자기 내려오지 않도록 안전지지대 또는 안전블록을 사용한다.",
          is_checked: "",
          title: "수리 등 점검 시",
        },
      ];
    },
    inspectTable_2() {
      return [
        {
          id: 1,
          label:
            "1. 굴착기 운전자의 적정 자격을 확인한다.\n" +
            "\t*3톤 미만 : 소형건설기계 조종교육 이수 \n" +
            "\t** 3톤 이상: 건설기계조종사면허(굴착기)",
          is_checked: "",
          title: "운전자 적정여부",
        },
        {
          id: 2,
          label:
            "굴착기 운행경로 및 작업방법 등을 고려한 작업계획을 수립하고 이행한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 3,
          label:
            "작업장소의 지형 및 지반상태를 확인하고, 굴착기가 넘어질 우려가 없도록 조치한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 4,
          label:
            "전조등의 정상적인 작동 및 사이드미러나 후사경의 설치상태가 양호한지 점검한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 5,
          label:
            "작업장소에 작업자의 출입을 통제하거나, 유도자를 배치하여 작업자가 부딪히지 않도록 유도한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 6,
          label: "운전원은 안전띠를 착용한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 7,
          label: "굴착기 버킷 이탈방지용 안전핀을 체결한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 8,
          label: "굴착기 버킷에 작업자의 탑승을 금지한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 9,
          label:
            "운전석 이탈 시 버킷은 지상에 내려놓고 시동키는 차에서 분리시켜야 한다.",
          is_checked: "",
          title: "운전자 이탈 시",
        },
        {
          id: 10,
          label:
            "붐·암 등이 갑자기 내려오지 않도록 안전지지대 또는 안전블록을 사용한다.",
          is_checked: "",
          title: "수리 등 점검시",
        },
      ];
    },
    inspectTable_3() {
      return [
        {
          id: 1,
          label:
            "고소작업대에 대한 작업계획서*를 작성하고 이행한다.\n" +
            "       *추락·낙하·전도·협착·붕괴 위험대책, 운행경로 및 작업방법",
          is_checked: "",
          title: "공통",
        },
        {
          id: 2,
          label:
            "작업지휘자 또는 유도자를 배치하여 작업계획서에 따라 작업을 지휘하여야 한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 3,
          label:
            "작업대에 탑승하는 작업자는 안전모 및 안전대를 착용하여야 한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 4,
          label: "작업대에 정격하중을 초과하여 물건을 싣거나 탑승하지 않는다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 5,
          label: "작업구간에 관계 작업자가 아닌 사람의 출입을 금지한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 6,
          label:
            "조종사의 적정 자격을 확인한다.\n" +
            "      *기중기운전기능사 또는 교육 이수",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 7,
          label: "안전인증 및 안전검사 실시 여부를 확인한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 8,
          label:
            "아웃트리거 및 브레이크 등을 확실히 사용하며 아웃트리거는 지면과 수평을 유지하도록 설치한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 9,
          label:
            "붐 길이와 각도에 적합한 적재하중 및 허용 작업반경을 확인한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 10,
          label: "안전인증 표시가 부착되어 있는지 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 11,
          label: "작업대 안전난간의 파손 및 탈락여부를 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 12,
          label: "고소작업대는 항상 바닥과 수평을 유지하도록 한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 13,
          label: "작업대에 과상승방지장치를 설치하고 작동유무를 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 14,
          label: "작업대를 올린 상태에서 작업자를 태우고 이동하지 않는다.",
          is_checked: "",
          title: "시저형",
        },
      ];
    },
    inspectTable_4() {
      return [
        {
          id: 1,
          label:
            "운전원은 적정 면허 자격*을 갖추어야 한다. \n" +
            "\t* 건설기계조종사면허(기중기) \n" +
            "\t** 기중기운전기능사 또는 교육 이수(카고크레인)",
          is_checked: "",
          title: "운전자 및 기계 적정여부",
        },
        {
          id: 2,
          label:
            "「건설기계관리법」상의 형식신고* 및「산업안전보건법」상 안전인증 및  안전검사** 여부를 확인한다.\n" +
            "\t* 기중기 \n" +
            "\t** 차량탑재형 크레인",
          is_checked: "",
          title: "운전자 및 기계 적정여부",
        },
        {
          id: 3,
          label:
            "작업전 작업자 배치 및 교육, 작업방법, 방호장치 등 필요한 사항에 대한 조치를 실시한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 4,
          label:
            "중량물 취급작업에 대한 작업계획을 수립하고 이행한다.\n" +
            "       *추락·낙하·전도·협착·붕괴위험을 예방할 수 있는 안전대책",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 5,
          label:
            "정격하중, 속도, 경고표시 등을 작업자가 보기 쉬운 곳에 부착한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 6,
          label:
            "과부하장지장치, 권과방지장치, 비상정지장치 및 제동장치, 그 밖의 방호장치가 정상적으로 작동하는지 점검한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 7,
          label:
            "인양 작업 구간에 작업자의 출입을 통제하여 인양 중인 하물이 작업자의 머리 위로 통과하지 않도록 한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 8,
          label:
            "이동식 크레인을 사용하여 작업자를 운반하거나 달아 올린 상태에서 작업을 실시하지 않는다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 9,
          label: "적재하중을 초과하지 않도록 작업한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 10,
          label: "훅 해지장치를 사용하여 인양물의 이탈을 방지한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 11,
          label: "운전자는 운전위치를 이탈하지 않는다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
      ];
    },
    inspectTable_5() {
      return [
        {
          id: 1,
          label:
            "운전원은 적정한 면허자격*을 갖추어야 한다.\n" +
            "\t* 덤프트럭(1종 대형), 화물자동차(12톤 이상: 1종 대형, 12톤 미만: 1종 보통)",
          is_checked: "",
          title: "운전원 자격확인",
        },
        {
          id: 2,
          label:
            "트럭 운행경로 및 작업방법 등을 고려한 작업계획을 수립하고 이행한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 3,
          label:
            "상하차 작업을 하는 장소에 지형 및 지반의 상태를 확인하고 덤프트럭이 넘어지지 않도록 조치한다.",
          is_checked: "",
          title: "운전 시작 전 안전조치",
        },
        {
          id: 4,
          label:
            "하역 또는 운반작업 구간에 작업자의 출입을 통제하거나, 유도자를 배치하여 작업자와의 충돌을 방지한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 5,
          label:
            "주·정차 시 브레이크를 체결하고 경사면인 경우 고임목을 설치한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 6,
          label: "적재함 상하차 작업 시 안전모를 착용한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 7,
          label: "화물 적재함에 근로자의 탑승 및 과적을 금지한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 8,
          label: "현장 내 제한속도를 표시하고 준수한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 9,
          label: "운전자는 안전벨트를 착용한다.",
          is_checked: "",
          title: "운행 및 작업 중 안전조치",
        },
        {
          id: 10,
          label:
            "운전자가 운전대를 이탈할 경우, 적재함을 내리고 시동 키를 운전석으로 분리한다.",
          is_checked: "",
          title: "운전자 이탈 시",
        },
      ];
    },
    inspectTable_6() {
      return [
        {
          id: 1,
          label:
            "타워크레인 운전원*의 자격을 확인한다.\n" +
            "      *건설기계조종사면허(타워크레인)",
          is_checked: "",
          title: "공통",
        },
        {
          id: 2,
          label: "타워크레인의 신호업무 담당자를 배치하고 교육한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 3,
          label: "타워크레인 상부 작업자는 안전모 및 안전대를 착용한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 4,
          label: "작업 구간에 관계 작업자가 아닌 사람의 출입을 금지한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 5,
          label:
            "중량물 취급작업에 대한 작업계획*을 수립·이행한다.\n" +
            "      *추락·낙하·전도·협착·붕괴위험을 예방할 수 있는 안전대책",
          is_checked: "",
          title: "공통",
        },
        {
          id: 6,
          label:
            "설치·해체 작업자의 자격*을 확인한다.\n" +
            "       *판금제관기능사 또는 비계기능사, 관련 교육 이수자",
          is_checked: "",
          title: "설치·해체 작업",
        },
        {
          id: 7,
          label:
            "설치·해체 작업에 대한 작업계획을 수립하고 제조사의 설치작업설명서 등에 따라 설치·해체한다.",
          is_checked: "",
          title: "설치·해체 작업",
        },
        {
          id: 8,
          label: "타워크레인 조립 시 작업의 순서를 정하고 그 순서를 준수한다.",
          is_checked: "",
          title: "설치·해체 작업",
        },
        {
          id: 9,
          label:
            "타워크레인에 충돌방지 장치를 설치하고, 설치·해체 작업 과정을 영상으로 기록·보존한다.",
          is_checked: "",
          title: "설치·해체 작업",
        },
        {
          id: 10,
          label: "자립고 이상에서 벽체 지지방법의 준수를 확인한다.",
          is_checked: "",
          title: "설치·해체 작업",
        },
        {
          id: 11,
          label:
            "정격하중, 속도, 경고표시 등을 작업자가 보기 쉬운 곳에 부착한다.",
          is_checked: "",
          title: "양중 작업",
        },
        {
          id: 12,
          label:
            "과부하장지장치, 권과방지장치, 비상정지장치 및 제동장치, 그 밖의 방호장치가 정상적으로 작동하는지 점검한다.",
          is_checked: "",
          title: "양중 작업",
        },
        {
          id: 13,
          label: "적재하중을 초과하지 않도록 작업한다.",
          is_checked: "",
          title: "양중 작업",
        },
        {
          id: 14,
          label: "훅 해지장치를 사용하여 인양물의 이탈을 방지한다.",
          is_checked: "",
          title: "양중 작업",
        },
        {
          id: 15,
          label: "운전자는 운전위치를 이탈하지 않는다.",
          is_checked: "",
          title: "양중 작업",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck_1(indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text;
    },
    updateListCheck_2(indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text;
    },
    updateListCheck_3(indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text;
    },
    updateListCheck_4(indexRows, text) {
      this.form.inspectList_4[indexRows].is_checked = text;
    },
    updateListCheck_5(indexRows, text) {
      this.form.inspectList_5[indexRows].is_checked = text;
    },
    updateListCheck_6(indexRows, text) {
      this.form.inspectList_6[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
